import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Installation from './components/Installation';
import WhatIsGit from './components/WhatIsGit';
import Workflow from './components/Workflow';
import FirstRepo from './components/FirstRepo';
import Commands from './components/Commands';
import Branching from './components/Branching';
import GitHub from './components/GitHub';
import Recetari from './components/Recetari';
import Videos from './components/Videos';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Installation />
      <WhatIsGit />
      <Workflow />
      <FirstRepo />
      <Commands />
      <Branching />
      <GitHub />
      <Recetari />
      <Videos />
      <Footer />
    </div>
  );
}

export default App;
